import React from 'react';
import { Router, Route, Link, hashHistory } from 'react-router';

import NavigationCheck from 'material-ui/svg-icons/navigation/check';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import CircularProgress from 'material-ui/CircularProgress';

const ScoreSheet = React.createClass({
	componentWillReceiveProps: function() {
		this._formatGuesses();
	},
	getInitialState: function() {
		return {
			answerKey: [],
			completed: 0
		}
	},
	_formatGuesses: function() {
		let quizKey = [];
		let numAnswers = 0;
		if (this.props.guesses.length) {
			for (var i = 0; i < this.props.guesses.length; i++) {
				for (var j = 0; j < this.props.questions.length; j++) {
					if (this.props.guesses[i].questionId == this.props.questions[j]._id) {
						quizKey.push({
							id: this.props.questions[j]._id,
							question: this.props.questions[j].question,
							guess: this.props.guesses[i].guess,
							answer: this.props.questions[j].answer
						});
						if (this.props.questions[j].answer) {
							numAnswers++;
						}
						break;
					}
				}
			}
		} else {
			for (var i = 0; i < this.props.questions.length; i++) {
				quizKey.push({
					id: this.props.questions[i]._id,
					question: this.props.questions[i].question,
					guess: '',
					answer: this.props.questions[i].answer
				});
				if (this.props.questions[i].answer) {
					numAnswers++;
				}
			}
		};

		this.setState({
			answerKey: quizKey,
			completed: (numAnswers/this.props.questions.length)*100
		});
	},
	_getQuizInfo: function() {
		const style = {
			correct: {
				fill: '#82CCC8',
			},
			incorrect: {
				fill: '#EBA97A',
			}
		};
		return this.state.answerKey.map((quiz, index) => {
			if (!this.props.guesses.length) {
				return (
					<div className="row" key={quiz.id}>
						<span className="index">{index + 1}</span>
						<div className="question">
							<div className="body">{quiz.question}</div>
							<div className="answer">Answer: {quiz.answer}</div>
						</div>
						<div className="icon"></div>
					</div>
				)
			} else if (quiz.answer && quiz.answer.toLowerCase() == quiz.guess.toLowerCase()) {
				return (
					<div className="row" key={quiz.id}>
						<span className="index">{index + 1}</span>
						<div className="question">
							<div className="body">{quiz.question}</div>
							<div className="answer">Answer: {quiz.answer}</div>
						</div>
						<div className="icon">
							<NavigationCheck style={style.correct} />
						</div>
					</div>
				)
			} else if (quiz.answer && quiz.answer.toLowerCase() != quiz.guess.toLowerCase()) {
				return (
					<div className="row" key={quiz.id}>
						<span className="index">{index + 1}</span>
						<div className="question">
							<div className="body">{quiz.question}</div>
							<div className="guess">Guess: {quiz.guess}</div>
							<div className="answer">Answer: {quiz.answer}</div>
						</div>
						<div className="icon">
							<NavigationClose style={style.incorrect} />
						</div>
					</div>
				)
			} else {
				return (
					<div className="row" key={quiz.id}>
						<span className="index">{index + 1}</span>
						<div className="question">
							<div className="body">{quiz.question}</div>
							<div className="guess">Guess: {quiz.guess}</div>
						</div>
						<div className="icon"></div>
					</div>
				)
			}
		})
	},
	render: function() {
		const style = {
			display: 'block',
			transform: 'rotate(-90deg)',
			WebkitTransform: 'rotate(-89deg)',
			border: '5px solid #eee',
			borderRadius: '50%',
			margin: '0 auto',
		}
		const quizList = this._getQuizInfo();
		if (!this.props.user.username) {
			if (this.props.status !== 'closed') {
				return (
					<div className="score-sheet">
						<div className="score">
							<CircularProgress
					          mode="determinate"
					          value={this.state.completed}
					          size={200}
					          thickness={5}
					          style={style}
					          color="#427AA1"
					        />
							<div className="info non-player">
								Quiz in progress
							</div>
						</div>
						<div className="questions">
							{quizList}
						</div>
					</div>
				)
			} else {
				return (
					<div className="score-sheet">
						<div>
							{quizList}
						</div>
					</div>
				)
			}
		} else if (this.props.user.username == localStorage.getItem('username')) {
			return (
				<div className="score-sheet">
					<div className="score">
						<CircularProgress
				          mode="determinate"
				          value={this.state.completed}
				          size={200}
				          thickness={5}
				          style={style}
				          color="#427AA1"
				        />
						<div className="info">
							<div className="user me">
								Your score
							</div>
							<div className="number">{this.props.selectedUserScore}</div>
						</div>
					</div>
					<div className="questions">
						{quizList}
					</div>
				</div>
			)
		} else {
			return (
				<div className="score-sheet">
					<div className="score">
						<CircularProgress
				          mode="determinate"
				          value={this.state.completed}
				          size={200}
				          thickness={5}
				          style={style}
				          color="#427AA1"
				        />
						<div className="info">
							<div className="user">
								{this.props.user.username}'s<br/>score
							</div>
							<div className="number">{this.props.selectedUserScore}</div>
						</div>
					</div>
					<div className="questions">
						{quizList}
					</div>
				</div>
			)
		}
	}
});

export default ScoreSheet;


// WEBPACK FOOTER //
// ./src/views/score.jsx